interface TreeIconProps {
  color?: string;
}

function TreeIcon({ color = "#cfd3af" }: TreeIconProps) {
  return (
    <svg
      width="17"
      height="24"
      viewBox="0 0 17 24"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        d="M8.43116 16.5843C8.41887 16.5843 8.40704 16.5827 8.3948 16.5826L8.04834 23.5939H10.3453L10.0063 16.7336C9.9941 16.4879 9.73884 16.3107 9.49988 16.3973C9.16732 16.5177 8.80758 16.5843 8.43116 16.5843Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M15.712 9.33581C16.223 8.6282 16.5268 7.76441 16.5268 6.82878C16.5268 4.44078 14.5685 2.50497 12.1529 2.50497C12.1171 2.50497 12.0824 2.50941 12.0468 2.51029C11.3007 1.37637 10.01 0.625 8.53967 0.625C6.83402 0.625 5.36939 1.63554 4.71799 3.08276C2.10402 3.75779 0.172241 6.1011 0.172241 8.89667C0.172241 10.4337 0.760274 11.8316 1.7198 12.8951C1.70323 13.0641 1.69354 13.2351 1.69354 13.4085C1.69354 16.3156 4.0775 18.6723 7.01827 18.6723C7.3388 18.6723 8.61529 18.644 8.91996 18.59L9.04884 17.2872C9.80226 17.6908 10.6651 17.9203 11.5823 17.9203C14.523 17.9203 16.907 15.5636 16.907 12.6565C16.9071 11.397 16.4584 10.2418 15.712 9.33581Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default TreeIcon;
